import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "SCHEDULING_TRANSPORT_" }
);

export interface SchedulingTransportState extends IState {}

const INITIAL_STATE: SchedulingTransportState = {
  loading: false,
  error: null,
};

const request = (state: SchedulingTransportState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: SchedulingTransportState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: SchedulingTransportState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const schedulingTransport = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const SchedulingTransportTypes = Types;
export const SchedulingTransportActions = Creators;
